import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline'
import DriveFileRenameOutlineIcon from '@mui/icons-material/DriveFileRenameOutline'
import {
  OptionsPopoverItems,
  type OptionItem,
} from '@/core/popover/options/OptionsPopoverItems.tsx'

export type TypeOptionPopoverItem = 'Rename' | 'Delete'

export interface TypeOptionsPopoverItemsProps {
  onItemSelected: (item: TypeOptionPopoverItem) => void
}

const options: OptionItem<TypeOptionPopoverItem>[] = [
  { value: 'Rename', label: 'Rename', icon: <DriveFileRenameOutlineIcon fontSize="small" /> },
  {
    value: 'Delete',
    label: 'Delete',
    icon: <DeleteOutlineIcon fontSize="small" />,
    isDelete: true,
  },
]

export function TypeOptionsPopoverItems({ onItemSelected }: TypeOptionsPopoverItemsProps) {
  return <OptionsPopoverItems options={options} onItemSelected={onItemSelected} />
}
